import PropTypes from 'prop-types';

export const answerPropTypes = PropTypes.arrayOf(PropTypes.shape({
  answer: PropTypes.string,
  number: PropTypes.string,
  task_number: PropTypes.string,
  criteria_number: PropTypes.string,
  criteria_name: PropTypes.string,
  mark: PropTypes.number,
  maxMark: PropTypes.number,
  answerType: PropTypes.string,
}));

export const answerDefaultProp = [
  {
    answer: null,
    number: null,
    mark: null,
    maxMark: null,
    task_number: null,
    criteria_number: null,
    criteria_name: null,
    answerType: null,
  },
];
